/* ===== BUNDLE ===== */
function pickBundle(el){
  document.querySelectorAll('.kb-bar').forEach(b=>b.classList.remove('sel'));
  el.classList.add('sel');
  document.querySelectorAll('.cdrop.open').forEach(x=>x.classList.remove('open'));
}
function toggleDrop(e,btn){
  e.stopPropagation();
  var d=btn.parentNode, wasOpen=d.classList.contains('open');
  document.querySelectorAll('.cdrop.open').forEach(x=>x.classList.remove('open'));
  if(!wasOpen) d.classList.add('open');
}
function pickDrop(e,opt,name,color){
  e.stopPropagation();
  var d=opt.closest('.cdrop'), btn=d.querySelector('.cdrop-btn');
  btn.querySelector('.cdot').style.background=color;
  btn.querySelector('.cname').textContent=name;
  d.classList.remove('open');
}
document.addEventListener('click',function(){
  document.querySelectorAll('.cdrop.open').forEach(x=>x.classList.remove('open'));
});

/* Timer du bundle — guardé : ne fait rien tant que #timer n'existe pas */
(function(){
  var el=document.getElementById('timer');
  if(!el) return;
  var s=14*60+59;
  setInterval(function(){
    if(s<=0) s=14*60+59;
    s--;
    var mm=String(Math.floor(s/60)).padStart(2,'0'), ss=String(s%60).padStart(2,'0');
    el.textContent=mm+':'+ss;
  },1000);
})();
function toggleNav(){document.getElementById('shDrawer').classList.toggle('open');document.getElementById('shOverlay').classList.toggle('open');}
function setMain(el){document.getElementById('mainimg').src=el.dataset.full||el.src;document.querySelectorAll('.gal-thumbs img').forEach(i=>i.classList.remove('sel'));el.classList.add('sel');}
function pickColor(el,name){document.querySelectorAll('.swatches .sw').forEach(s=>s.classList.remove('sel'));el.classList.add('sel');var ov=document.getElementById('optval');if(ov)ov.textContent=name;window.SPLASHR_COLOR=name;var map=window.SPLASHR_COLOR_IMG||{};var url=map[name];if(url){var mi=document.getElementById('mainimg');if(mi)mi.src=url;document.querySelectorAll('.gal-thumbs img').forEach(function(i){i.classList.toggle('sel',(i.dataset.full||i.src)===url);});}}
function pickBundle(el){document.querySelectorAll('.kb-bar').forEach(b=>b.classList.remove('sel'));el.classList.add('sel');document.querySelectorAll('.cdrop.open').forEach(x=>x.classList.remove('open'));}
function toggleDrop(e,btn){e.stopPropagation();var d=btn.parentNode,wasOpen=d.classList.contains('open');document.querySelectorAll('.cdrop.open').forEach(x=>x.classList.remove('open'));if(!wasOpen)d.classList.add('open');}
function pickDrop(e,opt,name,color){e.stopPropagation();var d=opt.closest('.cdrop'),btn=d.querySelector('.cdrop-btn');btn.querySelector('.cdot').style.background=color;btn.querySelector('.cname').textContent=name;d.classList.remove('open');}
document.addEventListener('click',function(){document.querySelectorAll('.cdrop.open').forEach(x=>x.classList.remove('open'));});
(function(){var m=['janv.','févr.','mars','avr.','mai','juin','juil.','août','sept.','oct.','nov.','déc.'];function f(d){return d.getDate()+' '+m[d.getMonth()]}function a(b,n){var d=new Date(b),c=0;while(c<n){d.setDate(d.getDate()+1);var w=d.getDay();if(w!==0&&w!==6)c++;}return d}var t=new Date();if(!document.getElementById('d1'))return;d1.textContent=f(t);d2.textContent=f(a(t,1));d3.textContent=f(a(t,3))+' – '+f(a(t,5));})();
(function(){var s=14*60+59;var el=document.getElementById('timer');if(!el)return;setInterval(function(){if(s<=0)s=14*60+59;s--;var mm=String(Math.floor(s/60)).padStart(2,'0'),ss=String(s%60).padStart(2,'0');el.textContent=mm+':'+ss;},1000);})();
(function(){
  var R=[
    {n:"Sarah M.",s:5,t:"Mes enfants sont devenus fous de ce truc ! L'effet feu d'artifice est dingue — meilleur jouet d'été qu'on ait acheté.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-1.avif?v=1781688812"},
    {n:"Jessica T.",s:5,t:"Arrose tout le jardin sans effort. Mon fils ne le lâche plus de la semaine. 100% vaut le coup.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/Adac5b4e8cd7247419aa02ef44d27a644L_jpg_960x960q75_jpg.avif?v=1776365853"},
    {n:"Mia K.",s:5,t:"Les couleurs sont superbes ! Tous les enfants à la piscine en voulaient un. J'en recommande.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/S3c57b6b6658b47aea94c8ae83bba7579u_jpg_960x960q75_jpg.avif?v=1776367552"},
    {n:"Emma L.",s:5,t:"On dirait vraiment un feu d'artifice qui sort d'un pistolet à eau. Ma fille était bouche bée.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/S38fe7b8214d44972b7f42068578c18f3r_jpg_960x960q75_jpg.avif?v=1776367552"},
    {n:"Lily R.",s:5,t:"Sans BPA et super solide. Parfait pour l'été. La portée est incroyable pour le prix.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/S60930e89c1144e1bbe3b4caa4337e954x_jpg_960x960q75_jpg.avif?v=1776367552"},
    {n:"Chloé B.",s:5,t:"J'en ai commandé deux, arrivés vite. Mes deux enfants adorent et les couleurs sont vives.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/Se8b558a03a664da3a2e32181b837fe8dd_jpg_960x960q75_jpg.avif?v=1776367552"},
    {n:"Ava N.",s:5,t:"Star de la piscine. L'effet de gerbe en feu d'artifice est bluffant pour les enfants.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/S11c35e30cf0541998e53c681679aae51D_jpg_960x960q75_jpg.avif?v=1776367552"},
    {n:"Zoé W.",s:5,t:"Offert en cadeau, succès immédiat. Facile à remplir, facile à utiliser, et magnifique.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/A76f74fe00d0349519220b2a212c25f9ep_jpg_960x960q75_jpg.avif?v=1776367553"},
    {n:"Grace H.",s:5,t:"Enfin un pistolet à eau qui impressionne vraiment. La portée de 8 m est réelle. Trop fun.",i:"https://cdn.shopify.com/s/files/1/0982/1362/6176/files/Sac6f87bb8da0420c9625415ff7b8f810u_jpg_960x960q75_jpg.avif?v=1776367553"},
    {n:"Olivia C.",s:5,t:"Mes jumeaux se disputaient pour la plus belle couleur. J'en ai pris un troisième. Aucun regret.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-2.avif?v=1781688813"},
    {n:"Isabella F.",s:5,t:"Super facile à manier pour les petites mains. Le jet d'eau est vraiment beau.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-3.avif?v=1781688814"},
    {n:"Sophia P.",s:5,t:"Utilisé à un anniversaire — chaque enfant voulait son tour. Succès garanti.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-4.avif?v=1781688816"},
    {n:"Harper J.",s:5,t:"Identique aux photos et la qualité est solide. Vraiment impressionnée.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-5.avif?v=1781688817"},
    {n:"Amélia D.",s:5,t:"Mes enfants sont restés dehors 3 heures grâce à ça. Vaut chaque centime.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-6.avif?v=1781688818"},
    {n:"Nora V.",s:4,t:"Produit très fun. Quelques minutes pour prendre le coup de main mais les enfants adorent.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-7.avif?v=1781688819"},
    {n:"Luna S.",s:4,t:"Bonne portée et l'effet feu d'artifice est vraiment cool. Bon achat d'été.",i:"https://cdn.shopify.com/s/files/1/0834/7903/6152/t/2/assets/review-8.avif?v=1781688821"}
  ];
  var per=8,shown=per,g=document.getElementById('rvgrid'),b=document.getElementById('rvbtn');if(!g||!b)return;
  function st(n){var s='';for(var i=0;i<5;i++)s+=i<n?'★':'☆';return s;}
  function render(){g.innerHTML='';for(var i=0;i<shown&&i<R.length;i++){var r=R[i];var c=document.createElement('div');c.className='rv-card';var im=r.i?'<img class="rv-img" src="'+r.i+'" loading="lazy" alt="">':'<div class="rv-noimg"></div>';c.innerHTML=im+'<div class="rv-b"><div class="rv-nm">'+r.n+'</div><div class="rv-s">'+st(r.s)+'</div><div class="rv-t">'+r.t+'</div><div class="rv-v"><svg viewBox="0 0 24 24" fill="none"><path d="M20 6L9 17l-5-5" stroke="#14b481" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>Achat vérifié</div></div>';g.appendChild(c);}if(shown>=R.length)b.style.display='none';}
  b.onclick=function(){shown+=4;render();};render();
})();
function splashrAddToCart(){
  var btns=document.querySelectorAll('.cta');
  for(var i=0;i<btns.length;i++){btns[i].classList.add('cta--loading');}
  var map=window.SPLASHR_VARIANTS||{};
  var id=(window.SPLASHR_COLOR&&map[window.SPLASHR_COLOR])||window.SPLASHR_FIRST_VARIANT;
  var kbSel=document.querySelector('.kb-bar.sel');var qty=kbSel?parseInt(kbSel.getAttribute('data-qty'),10):1;if(!qty||qty<1)qty=1;
  if(window.fbq){fbq('track','AddToCart',{content_ids:[window.SPLASHR_PID||String(id)],content_type:'product',value:(window.SPLASHR_PRICE||0)*qty,currency:'EUR'});}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:id,quantity:qty}]})})
    .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
    .then(function(res){
      if(res.ok){setTimeout(function(){window.location.href='/cart';},350);return;}
      for(var i=0;i<btns.length;i++){btns[i].classList.remove('cta--loading');}
      alert((res.d&&(res.d.description||res.d.message))||"Impossible d'ajouter au panier. Réessayez.");
    })
    .catch(function(){
      for(var i=0;i<btns.length;i++){btns[i].classList.remove('cta--loading');}
      alert("Impossible d'ajouter au panier. Vérifiez votre connexion et réessayez.");
    });
}

/* ===== GALERIE INTERACTIVE : vignettes (tactile) + swipe + lightbox/zoom + lien avis ===== */
(function(){
  var mainImg = document.getElementById('mainimg');
  var galMain = document.querySelector('.gal-main');
  var galThumbs = document.querySelector('.gal-thumbs');
  if(!mainImg || !galThumbs) return;

  function thumbs(){ return Array.prototype.slice.call(galThumbs.querySelectorAll('img')); }
  function fname(u){ return (u||'').split('?')[0].split('/').pop(); }

  function showByIndex(idx){
    var ts = thumbs(); if(!ts.length) return;
    idx = ((idx % ts.length) + ts.length) % ts.length;
    var t = ts[idx], url = t.dataset.full || t.src;
    mainImg.src = url;
    ts.forEach(function(i){ i.classList.remove('sel'); });
    t.classList.add('sel');
  }
  function currentIndex(){
    var ts = thumbs(), cf = fname(mainImg.currentSrc || mainImg.src);
    for(var i=0;i<ts.length;i++){ if(fname(ts[i].dataset.full||ts[i].src)===cf) return i; }
    var sel = galThumbs.querySelector('img.sel'); return sel ? ts.indexOf(sel) : 0;
  }

  /* Vignette -> image principale (tactile robuste : touchend + click, anti-double) */
  var lastThumbTouch = 0;
  function pickThumb(img){ var ts = thumbs(), idx = ts.indexOf(img); if(idx>=0) showByIndex(idx); }
  galThumbs.addEventListener('touchend', function(e){
    var img = e.target.closest('img'); if(!img) return;
    lastThumbTouch = Date.now(); pickThumb(img);
  }, {passive:true});
  galThumbs.addEventListener('click', function(e){
    if(Date.now()-lastThumbTouch < 600) return;
    var img = e.target.closest('img'); if(!img) return;
    pickThumb(img);
  });

  /* Swipe horizontal sur l'image principale */
  var sx=0, sy=0, lastSwipe=0;
  if(galMain){
    galMain.addEventListener('touchstart', function(e){ var t=e.touches[0]; sx=t.clientX; sy=t.clientY; }, {passive:true});
    galMain.addEventListener('touchend', function(e){
      var t=e.changedTouches[0], dx=t.clientX-sx, dy=t.clientY-sy;
      if(Math.abs(dx)>40 && Math.abs(dx)>Math.abs(dy)*1.4){
        showByIndex(currentIndex() + (dx<0?1:-1));
        lastSwipe = Date.now();
        e.preventDefault();
      }
    }, {passive:false});
  }

  /* Lightbox / zoom au tap sur l'image principale */
  var lb=null;
  function buildLb(){
    lb=document.createElement('div'); lb.id='splashr-lightbox';
    lb.innerHTML='<button class="lb-close" type="button" aria-label="Fermer">&times;</button><img alt="">';
    document.body.appendChild(lb);
    var lbImg=lb.querySelector('img');
    lb.addEventListener('click', function(e){ if(e.target===lb || e.target.classList.contains('lb-close')) closeLb(); });
    lbImg.addEventListener('click', function(e){ e.stopPropagation(); lbImg.classList.toggle('zoomed'); });
  }
  function openLb(){
    if(!lb) buildLb();
    var lbImg=lb.querySelector('img'); lbImg.classList.remove('zoomed');
    lbImg.src=mainImg.currentSrc||mainImg.src;
    lb.classList.add('open'); document.documentElement.classList.add('lb-lock');
  }
  function closeLb(){ if(lb){ lb.classList.remove('open'); document.documentElement.classList.remove('lb-lock'); } }
  mainImg.addEventListener('click', function(){
    if(Date.now()-lastSwipe < 400) return;
    openLb();
  });

  /* Bloc note 4,9/5 -> scroll vers les avis */
  var rw=document.querySelector('.rw');
  var reviews=document.querySelector('.rv') || document.querySelector('.stest');
  if(rw && reviews){
    rw.style.cursor='pointer'; rw.setAttribute('role','button'); rw.setAttribute('tabindex','0');
    rw.addEventListener('click', function(){ reviews.scrollIntoView({behavior:'smooth', block:'start'}); });
  }
})();


/* ===== BUNDLE v2 : couleur par pistolet (override) ===== */
function pickDrop(e,opt,name,color){
  e.stopPropagation();
  var d=opt.closest('.cdrop'),btn=d.querySelector('.cdrop-btn');
  btn.querySelector('.cdot').style.background=color;
  btn.querySelector('.cname').textContent=name;
  d.setAttribute('data-color',name);
  d.classList.remove('open');
}
function splashrAddToCart(){
  var btns=document.querySelectorAll('.cta');
  for(var i=0;i<btns.length;i++){btns[i].classList.add('cta--loading');}
  var map=window.SPLASHR_VARIANTS||{};
  var kbSel=document.querySelector('.kb-bar.sel');
  var qty=kbSel?parseInt(kbSel.getAttribute('data-qty'),10):1; if(!qty||qty<1)qty=1;
  var items=[]; var drops=kbSel?kbSel.querySelectorAll('.kb-colors .cdrop'):[];
  if(drops&&drops.length){
    for(var j=0;j<drops.length;j++){
      var col=drops[j].getAttribute('data-color')||window.SPLASHR_COLOR||'';
      items.push({id:(map[col]||window.SPLASHR_FIRST_VARIANT),quantity:1});
    }
  } else {
    var id=(window.SPLASHR_COLOR&&map[window.SPLASHR_COLOR])||window.SPLASHR_FIRST_VARIANT;
    items.push({id:id,quantity:qty});
  }
  var tq=0; for(var k=0;k<items.length;k++){tq+=items[k].quantity;}
  if(window.fbq){fbq('track','AddToCart',{content_ids:[window.SPLASHR_PID],content_type:'product',value:(window.SPLASHR_PRICE||0)*tq,currency:'EUR'});}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
    .then(function(r){return r.json().then(function(d){return {ok:r.ok,d:d};});})
    .then(function(res){
      if(res.ok){setTimeout(function(){window.location.href='/cart';},350);return;}
      for(var i=0;i<btns.length;i++){btns[i].classList.remove('cta--loading');}
      alert((res.d&&(res.d.description||res.d.message))||"Impossible d'ajouter au panier. Réessayez.");
    })
    .catch(function(){
      for(var i=0;i<btns.length;i++){btns[i].classList.remove('cta--loading');}
      alert("Impossible d'ajouter au panier. Vérifiez votre connexion et réessayez.");
    });
}

